export const environment = {
  production: false,
  apiUrl: 'https://api.suitelifetools.com/staging',
};
